export const getSectionData = ({
  tenantInformation = {},
  moveInDetails = [],
  tenantAlternateInformation = {},
  militaryInformation = [],
  AccountCreation = [],
} = {}) => {
  return [
    {
      id: 1,
      data: {
        ...tenantInformation,
        moveInDetails,
      },
    },
    {
      id: 2,
      data: {
        ...tenantAlternateInformation,
      },
    },
    {
      id: 3,
      data: {
        militaryInformation,
        AccountCreation,
      },
    },

    {
      id: 4,
      data: '',
    },
    {
      id: 5,
      data: '',
    },
  ];
};
